import React, { useCallback, useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import "bootstrap/dist/css/bootstrap.min.css"
// import TableContainer from "../../components/Common/TableContainer"
import * as Yup from "yup"
import toastr from "toastr"
import "toastr/build/toastr.min.css";
import { useFormik } from "formik"
// import Breadcrumbs from "../../components/Common/Breadcrumb"
import Switch from "react-switch"
import { makeStyles } from "@material-ui/core/styles"
import {
  Divider, Tooltip, TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow, Table,
  TableBody,
  TextField,InputAdornment
} from "@material-ui/core"
// import {
//   getUsers as onGetUsers,
//   addNewUser as onAddNewUser,
//   updateUser as onUpdateUser,
//   deleteUser as onDeleteUser,
// } from "../../store/actions"
import { styled } from "@mui/system"
import classnames from "classnames"
import Select from "react-select"
import { Dialog, DialogTitle } from "@material-ui/core"
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardTitle,
  Button,
  Nav,
  CardBody,
  NavItem,
  NavLink,
  Container,
  TabContent,
  TabPane,
} from "reactstrap"
// import DeleteModal from "../../components/Common/DeleteModal"
import axios from "../../axios"
import SweetAlert from "react-bootstrap-sweetalert"
import moment from "moment"
// import { Divider } from "@material-ui/core"

import TrendingFlatIcon from "@mui/icons-material/TrendingFlat"
import CloudUploadIcon from "@mui/icons-material/CloudUpload"
import { Button as MuiButton, Button as CustomButton2 } from "@material-ui/core"
import { Margin } from "@mui/icons-material"
const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  dialogpaper: {
    width: "1200px",
  },
}))

const CustomButton = styled(Button)({
  boxShadow: 0,
  marginLeft: 5,
  backgroundColor: "#3468C0",
  color: "#yourCustomTextColor",
  "&:hover": {
    backgroundColor: "#2c3e50",
  },
})

function CompanyMaster() {
  const [noRecords, setnoRecords] = useState(false)

  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [tokent, settokent] = useState(
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ"
  )
  const [switch1, setswitch1] = useState(true)
  const [userList, setUserList] = useState([])
  const [activeTab, setactiveTab] = useState("1")
  const [Deletiid, setDeletiid] = useState("")
  const [Buyerinfo, setBuyerinfo] = useState(false)
  const [Buyersuccess, setBuyersuccess] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [Buyererr, setBuyererr] = useState(false)
  const [CantDeleteErr, setCantDeleteErr] = useState(false)
  const [allcustomercollections, setallcustomercollections] = useState([])
  const PhoneRegExps = /^[0-9 () +-]+$/
  const [allcountrycollections, setallcountrycollections] = useState([])
  const [allcitycollections, setallcitycollections] = useState([])
  const [allstatecollections, setallstatecollections] = useState([])
  const [duplicateerro, setduplicateerro] = useState(false)
  const [cityonedefaultvalue, setcityonedefaultvalue] = useState({
    label: "Select...",
    value: "",
  })

  const [bankcollectoin, setbankcollectoin] = useState([])
  const [bankdefaultvalue, setbankdefaultvalue] = useState({
    label: "Select...",
    value: "0",
  })
  const [onestatedefaultvalue, setonestatedefaultvalue] = useState({
    label: "Select...",
    value: "",
    id: "",
  })
  const [onecountrydefaultvalue, setonecountrydefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [registerdate, setregisterdate] = useState("")
  const [Active1, setActive1] = useState(true)
  const [Active2, setActive2] = useState(false)
  const [countryErr, setcountryErr] = useState(false)
  const [stateErr, setstateErr] = useState(false)
  const [cityErr, setcityErr] = useState(false)

  // company logo
  const [ProofDocumentLoad1, setProofDocumentLoad1] = useState("")
  const [ProofDocumentLoadAttach1, setProofDocumentLoadAttach1] = useState("")
  const [ProofDocumentLoadName1, setProofDocumentLoadName1] = useState("")
  const [ImageInsert, setImageInsert] = useState(false)

  // Banner logo
  const [ProofDocumentLoad2, setProofDocumentLoad2] = useState("")
  const [ProofDocumentLoadAttach2, setProofDocumentLoadAttach2] = useState("")
  const [ProofDocumentLoadName2, setProofDocumentLoadName2] = useState("")
  const [ImageInsert1, setImageInsert1] = useState(false)

  const [Suffix, setSuffix] = useState('')
  // previewcompany
  const [Popupimage, setPopupimage] = useState("")
  const [open, setopen] = useState(false)

  //previewBanner
  const [Popupimage1, setPopupimage1] = useState("")
  const [open1, setopen1] = useState(false)

  const [BuyerCollection, setBuyerCollection] = useState({
    Company_Id: "",
    Company_Name: "",
    Company_Code: "",
    Contact_Person: "",
    Address1: "",
    Address2: "",
    Area_Code: "",
    Phone: "",
    Zip_Code: "",
    Fax: "",
    PAN_No: "",
    WebSit: "",
    Prefix: "",
    DrugLicense: "",
    CST: "",
    Banner: "",
    TNGST: "",
    EmailId: "",
    mailpassword: "",
    SMTPPort: "",
    SMTPServer: "",
    CCEmailId: "",
    CCRequired: "",
    Invoice_username: "",
    Invoice_password: "",
  })

  
    const pages = [
      5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 150, 200, 250, 300, 400, 500,
      600, 700, 800, 900, 1000,
    ];
    const [page, setpage] = useState(0);
    const [rowsperpage, setrowsperpage] = useState(pages[page]);
  
    const [branchid, setbranchid] = useState("")
  
    const [deletedconfirm, setdeletedconfirm] = useState(false);

    const [deletid, setdeletid] = useState("")

  function toggle12(tab) {
    if (activeTab !== tab) {
      setactiveTab(tab)
    }
  }

  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setrowsperpage(parseInt(event.target.value, 10));
    // setpage(0);
  };

  const changepage = () => {
    return allcustomercollections.slice(
      page * rowsperpage,
      (page + 1) * rowsperpage,
    );
  };


  const tab1validtiontab1 = tab => {
    if (
      validation.values.Company_Name.length > 0 &&
      validation.values.Address1.length >= 1 &&
      validation.values.Phone.toString().length > 9 &&
      validation.values.Zip_Code.toString().length >= 6 &&
      validation.values.PAN_No.length > 0 &&
      cityonedefaultvalue.value !== "" &&
      onestatedefaultvalue.value !== "" &&
      onecountrydefaultvalue.value !== ""
    ) {
      if (activeTab !== tab) {
        setactiveTab(tab)
      }
    } else {
      validation.setFieldTouched("Company_Name")
      validation.setFieldTouched("Address1")
      validation.setFieldTouched("Phone")
      validation.setFieldTouched("Zip_Code")
      validation.setFieldTouched("PAN_No")
      if (cityonedefaultvalue.value === "") {
        setcityErr(true)
      }
      if (onestatedefaultvalue.value === "") {
        setstateErr(true)
      }
      if (onecountrydefaultvalue.value === "") {
        setcountryErr(true)
      }

      setTimeout(() => {
        setcityErr(false)
        setstateErr(false)
        setcountryErr(false)
      }, 1000)
      // validation.setFieldTouched('EmailId')
    }
  }

  const tab1validtiontab2 = tab => {
    if (validation.values.TNGST.length > 14) {
      if (activeTab !== tab) {
        setactiveTab(tab)
      }
    } else {
      validation.setFieldTouched("TNGST")
    }
  }

  const phoneRegExp = /^[0-9 () +-]+$/
  const Country = /^[a-zA-Z ]+$/
  // validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: BuyerCollection,
    validationSchema: Yup.object({
      Company_Name: Yup.string()
        .required("Please Enter Company Name")
        .max(100, "Company Name Must Be Atmost 100 Characters"),
      Contact_Person: Yup.string().max(
        50,
        "Contact Person Must Be Atmost 50 Characters"
      ),
      Address1: Yup.string().required("Please Enter Address1"),
      Zip_Code: Yup.string()
        .required("Please Enter Pin Code ")
        .min(6, "Pin Code Must Be atleast 6 Digits"),
      Phone: Yup.string()
        .min(10, "Phone No Must Be Atleast 10 Digits")
        .max(15, "Phone No Must Be Atmost 15 Digits")
        .matches(PhoneRegExps, "Please Enter valid Phone No"),
      EmailId: Yup.string().email("EmailId  Must Be Valid"),
      CCEmailId: Yup.string().email("CCEmailId  Must Be Valid"),
      TNGST: Yup.string()
        .min(15, "GST No Must Be Atleast 15 Digits")
        .max(15, "GST No Must Be Atmost 15 Digits")
        .required("Please Enter GST No"),
      PAN_No: Yup.string()
        .required("Please Enter PAN No")
        .max(30, "PAN No Must Be Atmost 30 Characters")
        .transform((value, originalValue) => originalValue.toUpperCase()),
    }),
    onSubmit: async values => {
      if (isEdit) {
        // let modifiedUrl
        // let originalUrl = ProofDocumentLoadAttach1
        // console.log(ProofDocumentLoadAttach1,'load')
        // console.log(ProofDocumentLoadName1,'name')
        // const baseUrl = `${axios.baseURL}/`
        // if (typeof originalUrl !== "object") {
        //   modifiedUrl = originalUrl.replace(baseUrl, "")
        // } else {
        //   modifiedUrl = ProofDocumentLoadAttach1
        // }

        // let modifiedUrl1
        // let originalUrl1 = ProofDocumentLoadAttach2
        // console.log(ProofDocumentLoadAttach2,'load')
        // console.log(ProofDocumentLoadName2,'name')
        // const baseUrl1 = `${axios.baseURL}/`
        // if (typeof originalUrl1 !== "object") {
        //   modifiedUrl1 = originalUrl1.replace(baseUrl1, "")
        // } else {
        //   modifiedUrl1 = ProofDocumentLoadAttach2
        // }

        let modifiedUrl
        let originalUrl = ProofDocumentLoadName1
        console.log(ProofDocumentLoadAttach1, "load")
        console.log(ProofDocumentLoadName1, "name")
        const baseUrl = `${axios.baseURL}/`
        modifiedUrl =
          typeof originalUrl !== "object"
            ? ProofDocumentLoadAttach1
            : ProofDocumentLoadName1

        let modifiedUrl1
        let originalUrl1 = ProofDocumentLoadName2
        console.log(ProofDocumentLoadAttach2, "load")
        console.log(ProofDocumentLoadName2, "name")
        const baseUrl1 = `${axios.baseURL}/`
        modifiedUrl1 =
          typeof originalUrl1 !== "object"
            ? ProofDocumentLoadAttach2
            : ProofDocumentLoadName2

        const formdata = new FormData()
        formdata.append("Optype", "Edit")
        formdata.append("Company_Id", values.Company_Id)
        formdata.append("Company_Name", values.Company_Name)
        formdata.append("Company_Code", "")
        formdata.append("Contact_Person", values.Contact_Person)
        formdata.append("Address1", values.Address1)
        formdata.append("Address2", values.Address2)
        formdata.append("Area_Code", values.Area_Code)
        formdata.append("City", cityonedefaultvalue.label)
        formdata.append("Zip_Code", values.Zip_Code)
        formdata.append("State", onestatedefaultvalue.label)
        formdata.append("Country", onecountrydefaultvalue.label)
        formdata.append("Phone", values.Phone)
        formdata.append("Fax", values.Fax)
        formdata.append("EmailId", values.EmailId)
        formdata.append("TNGST", values.TNGST)
        formdata.append("CST", values.CST)
        formdata.append("TIN_No", registerdate)
        formdata.append("WebSit", values.WebSit)
        formdata.append("Remarks", "")
        formdata.append("Banner", values.Banner)
        formdata.append("CompanyLogo", "")
        formdata.append("Modify_By", sessionStorage.getItem("Userid"))
        formdata.append("Modify_Date", new Date())
        formdata.append("Active", switch1 ? "Y" : "N")
        formdata.append("mailpassword", values.mailpassword)
        formdata.append("SMTPServer", values.SMTPServer)
        formdata.append("SMTPPort", values.SMTPPort)
        formdata.append("SSLRequired", Active2 ? 1 : 0)
        formdata.append("CCRequired", 0)
        formdata.append("CCEmailId", values.CCEmailId)
        formdata.append("Bank", bankdefaultvalue.label)
        formdata.append("IFSC", "")
        formdata.append("AccNo", "")
        formdata.append("PanNo", values.PAN_No)
        formdata.append("Bank_Id", bankdefaultvalue.value)
        formdata.append("IssueDate", new Date())
        formdata.append("ExpiryDate", new Date())
        formdata.append("StateCode", onestatedefaultvalue.value)
        formdata.append("StateId", onestatedefaultvalue.id)
        formdata.append("Prefix", values.Prefix)
        formdata.append("DrugLicense", values.DrugLicense)
        formdata.append("BannerLogo", "")
        formdata.append("Invoice_username", values.Invoice_username)
        formdata.append("Invoice_password", values.Invoice_password)
        formdata.append("Suffix", Suffix)
        formdata.append("Banner_Logo_Web", modifiedUrl1)
        formdata.append("Company_Logo_Web", modifiedUrl)
        const CreateBuyer = await axios.instance
          .post(
            `/InsertCompanyMst`,
            formdata,
            // {
            //   Optype: "Edit",
            //   Company_Id: values.Company_Id,
            //   Company_Name: values.Company_Name,
            //   Company_Code: "",
            //   Contact_Person: values.Contact_Person,
            //   Address1: values.Address1,
            //   Address2: values.Address2,
            //   Area_Code: values.Area_Code,
            //   City: cityonedefaultvalue.label,
            //   Zip_Code: values.Zip_Code,
            //   State: onestatedefaultvalue.label,
            //   Country: onecountrydefaultvalue.label,
            //   Phone: values.Phone,
            //   Fax: values.Fax,
            //   EmailId: values.EmailId,
            //   TNGST: values.TNGST,
            //   CST: values.CST,
            //   TIN_No: registerdate,
            //   WebSit: values.WebSit,
            //   Remarks: "",
            //   Banner: values.Banner,
            //   CompanyLogo: "",
            //   Modify_By: sessionStorage.getItem('Userid'),
            //   Modify_Date: new Date(),
            //   // Created_By:"1",
            //   // Created_Date:new Date(),
            //   Active: switch1 ? "Y" : "N",
            //   mailpassword: values.mailpassword,
            //   SMTPServer: values.SMTPServer,
            //   SMTPPort: values.SMTPPort,
            //   SSLRequired: Active2 ? 1 : 0,
            //   CCRequired: 0,
            //   CCEmailId: values.CCEmailId,
            //   Bank: bankdefaultvalue.label,
            //   IFSC: "",
            //   AccNo: "",
            //   PanNo: values.PAN_No,
            //   Bank_Id: bankdefaultvalue.value,
            //   IssueDate: new Date(),
            //   ExpiryDate: new Date(),
            //   StateCode: onestatedefaultvalue.value,
            //   StateId: onestatedefaultvalue.id,
            //   Prefix: values.Prefix,
            //   DrugLicense: values.DrugLicense,
            //   BannerLogo: "",
            //   Invoice_username: values.Invoice_username,
            //   Invoice_password: values.Invoice_password,
            // },
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then(res => {
            // Getonecountry()
            console.log(res.data,'res.data')
            if (res.data.length === 1) {
             
              getallcustomers1(Active1)
              setbankdefaultvalue({ label: "Select...", value: "0" })
              setswitch1(true)
              setActive2(false)
              setSuffix('') 
              setonestatedefaultvalue({ label: "Select...", value: "", id: "" })
              setonecountrydefaultvalue({ label: "Select...", value: "" })
              setcityonedefaultvalue({ label: "Select...", value: "" })
              setregisterdate("")
              setBuyerCollection({
                Company_Id: "",
                Company_Name: "",
                Company_Code: "",
                Contact_Person: "",
                Address1: "",
                Address2: "",
                Area_Code: "",
                Phone: "",
                Zip_Code: "",
                Fax: "",
                PAN_No: "",
                WebSit: "",
                Prefix: "",
                DrugLicense: "",
                CST: "",
                Banner: "",
                TNGST: "",
                EmailId: "",
                mailpassword: "",
                SMTPPort: "",
                SMTPServer: "",
                CCEmailId: "",
                CCRequired: "",
                Invoice_username: "",
                Invoice_password: "",
              })
              validation.resetForm()
              setactiveTab("1")
              setModal(false)
              setBuyerinfo(true)
            } else {
              setduplicateerro(true)
            }
          })
      } else {
        const formdata = new FormData()
        formdata.append("Optype", "New")
        formdata.append("Company_Id", "")
        formdata.append("Company_Name", values.Company_Name)
        formdata.append("Company_Code", "")
        formdata.append("Contact_Person", values.Contact_Person)
        formdata.append("Address1", values.Address1)
        formdata.append("Address2", values.Address2)
        formdata.append("Area_Code", values.Area_Code)
        formdata.append("City", cityonedefaultvalue.label)
        formdata.append("Zip_Code", values.Zip_Code)
        formdata.append("State", onestatedefaultvalue.label)
        formdata.append("Country", onecountrydefaultvalue.label)
        formdata.append("Phone", values.Phone)
        formdata.append("Fax", values.Fax)
        formdata.append("EmailId", values.EmailId)
        formdata.append("TNGST", values.TNGST)
        formdata.append("CST", values.CST)
        formdata.append("TIN_No", registerdate)
        formdata.append("WebSit", values.WebSit)
        formdata.append("Remarks", "")
        formdata.append("Banner", values.Banner)
        formdata.append("CompanyLogo", "")
        formdata.append("Created_By", sessionStorage.getItem("Userid"))
        formdata.append("Created_Date", new Date())
        formdata.append("Active", switch1 ? "Y" : "N")
        formdata.append("mailpassword", values.mailpassword)
        formdata.append("SMTPServer", values.SMTPServer)
        formdata.append("SMTPPort", values.SMTPPort)
        formdata.append("SSLRequired", Active2 ? 1 : 0)
        formdata.append("CCRequired", 0)
        formdata.append("CCEmailId", values.CCEmailId)
        formdata.append("Bank", bankdefaultvalue.label)
        formdata.append("IFSC", "")
        formdata.append("AccNo", "")
        formdata.append("PanNo", values.PAN_No)
        formdata.append("Bank_Id", bankdefaultvalue.value)
        formdata.append("IssueDate", new Date())
        formdata.append("ExpiryDate", new Date())
        formdata.append("StateCode", onestatedefaultvalue.value)
        formdata.append("StateId", onestatedefaultvalue.id)
        formdata.append("Prefix", values.Prefix)
        formdata.append("DrugLicense", values.DrugLicense)
        formdata.append("BannerLogo", "")
        formdata.append("Suffix", Suffix)
        formdata.append("Invoice_username", values.Invoice_username)
        formdata.append("Invoice_password", values.Invoice_password)
        formdata.append("Banner_Logo_Web", ProofDocumentLoadName2)
        formdata.append("Company_Logo_Web", ProofDocumentLoadName1)

        // Now, make the axios request using the FormData
        const CreateBuyer = await axios.instance
          .post("/InsertCompanyMst", formdata, {
            headers: {
              Authorization: tokent,
              "Content-Type": "multipart/form-data",
            },
          })

          // const CreateBuyer = await axios.instance
          //   .post(
          //     `/InsertCompanyMst`, formdata,
          //     {
          //       Optype: "New",
          //       Company_Id: "",
          //       Company_Name: values.Company_Name,
          //       Company_Code: "",
          //       Contact_Person: values.Contact_Person,
          //       Address1: values.Address1,
          //       Address2: values.Address2,
          //       Area_Code: values.Area_Code,
          //       City: cityonedefaultvalue.label,
          //       Zip_Code: values.Zip_Code,
          //       State: onestatedefaultvalue.label,
          //       Country: onecountrydefaultvalue.label,
          //       Phone: values.Phone,
          //       Fax: values.Fax,
          //       EmailId: values.EmailId,
          //       TNGST: values.TNGST,
          //       CST: values.CST,
          //       TIN_No: registerdate,
          //       WebSit: values.WebSit,
          //       Remarks: "",
          //       Banner: values.Banner,
          //       CompanyLogo: "",
          //       // Modify_By:1
          //       // Modify_Date:""
          //       Created_By: sessionStorage.getItem('Userid'),
          //       Created_Date: new Date(),
          //       Active: switch1 ? "Y" : "N",
          //       mailpassword: values.mailpassword,
          //       SMTPServer: values.SMTPServer,
          //       SMTPPort: values.SMTPPort,
          //       SSLRequired: Active2 ? 1 : 0,
          //       CCRequired: 0,
          //       CCEmailId: values.CCEmailId,
          //       Bank: bankdefaultvalue.label,
          //       IFSC: "",
          //       AccNo: "",
          //       PanNo: values.PAN_No,
          //       Bank_Id: bankdefaultvalue.value,
          //       IssueDate: new Date(),
          //       ExpiryDate: new Date(),
          //       StateCode: onestatedefaultvalue.value,
          //       StateId: onestatedefaultvalue.id,
          //       Prefix: values.Prefix,
          //       DrugLicense: values.DrugLicense,
          //       BannerLogo: "",
          //       Invoice_username: values.Invoice_username,
          //       Invoice_password: values.Invoice_password,

          //     },
          //     {
          //       headers: {
          //         Authorization: tokent,
          //         "Content-Type": "multipart/form-data",
          //       },
          //     }
          //   )
          .then(res => {
            if (res.data.length === 1) {
               
                console.log(res.data[0].Company_Id)
                insertstockrights(res.data[0].Company_Id)
              // for (const data of response) {
                // insertstockrights(response)
              // }
               
              setSuffix('') 
              getallcustomers1(Active1)
              setbankdefaultvalue({ label: "Select...", value: "0" })
              setswitch1(true)
              setActive2(false)
              setonestatedefaultvalue({ label: "Select...", value: "", id: "" })
              setonecountrydefaultvalue({ label: "Select...", value: "" })
              setcityonedefaultvalue({ label: "Select...", value: "" })
              setregisterdate("")
              setBuyerCollection({
                Company_Id: "",
                Company_Name: "",
                Company_Code: "",
                Contact_Person: "",
                Address1: "",
                Address2: "",
                Area_Code: "",
                Phone: "",
                Zip_Code: "",
                Fax: "",
                PAN_No: "",
                WebSit: "",
                Prefix: "",
                DrugLicense: "",
                CST: "",
                Banner: "",
                TNGST: "",
                EmailId: "",
                mailpassword: "",
                SMTPPort: "",
                SMTPServer: "",
                CCEmailId: "",
                CCRequired: "",
                Invoice_username: "",
                Invoice_password: "",
              })
              validation.resetForm()
              setactiveTab("1")
              setModal(false)
              // toggle()
              setBuyersuccess(true)
            } else {
              setduplicateerro(true)
            }
          })
      }
    },
  })

  // const toggleViewModal = () => setModal1(!modal1);

  const toggle = () => {
    // if (modal) {
    // setIsEdit(false)
    setModal(false)
    // setUser(null)
    setswitch1(true)
    setActive2(false)
    setSuffix('') 
    setBuyerCollection({
      Company_Id: "",
      Company_Name: "",
      Company_Code: "",
      Contact_Person: "",
      Address1: "",
      Address2: "",
      Area_Code: "",
      Phone: "",
      Zip_Code: "",
      Fax: "",
      PAN_No: "",
      WebSit: "",
      Prefix: "",
      DrugLicense: "",
      CST: "",
      Banner: "",
      TNGST: "",
      EmailId: "",
      mailpassword: "",
      SMTPPort: "",
      SMTPServer: "",
      CCEmailId: "",
      CCRequired: "",
      Invoice_username: "",
      Invoice_password: "",
      Banner_Logo_Web: "",
      Company_Logo_Web: "",
    })
    setbankdefaultvalue({ label: "Select...", value: "0" })
    setonestatedefaultvalue({ label: "Select...", value: "", id: "" })
    setonecountrydefaultvalue({ label: "Select...", value: "" })
    setcityonedefaultvalue({ label: "Select...", value: "" })
    setregisterdate("")
    validation.resetForm()
    setactiveTab("1")
    // } else {
    //   setModal(true)
    //   Getonecity()
    //   Getonestates()
    //   Getonecountry()
    // }
  }

  const handleUserClick = arg => {
    const Buyer = arg
    console.log(arg, "value")

    if (Buyer.active === "Y") {
      setswitch1(true)
    } else {
      setswitch1(false)
    }
    setSuffix(Buyer.Suffix)
    setBuyerCollection({
      Company_Id: Buyer.company_id,
      Company_Name: Buyer.company_name,
      Company_Code: Buyer.company_code,
      Contact_Person: Buyer.contact_person,
      Address1: Buyer.address1,
      Address2: Buyer.address2,
      Area_Code: Buyer.area_code,
      Zip_Code: Buyer.zip_code,
      Phone: Buyer.phone,
      Fax: Buyer.fax,
      EmailId: Buyer.emailid,
      TNGST: Buyer.tngst,
      CST: Buyer.cst,
      WebSit: Buyer.websit,
      Banner: Buyer.banner,
      mailpassword: Buyer.mailpassword,
      SMTPServer: Buyer.smtpserver,
      SMTPPort: Buyer.smtpport,
      CCRequired: Buyer.ccrequired,
      CCEmailId: Buyer.ccemailid,
      PAN_No: Buyer.panno,
      Prefix: Buyer.prefix,
      DrugLicense: Buyer.druglicense,
      Invoice_username: Buyer.e_invoice_username,
      Invoice_password: Buyer.e_invoice_password,
      // Banner_Logo_Web:Buyer.Banner_Logo_Web,
      // Company_Logo_Web:Buyer.Company_Logo_Web,
    })
    setActive2(Buyer.sslrequired)
    setregisterdate(Buyer.tin_no)
    setcityonedefaultvalue({ label: Buyer.city, value: Buyer.city })
    setonestatedefaultvalue({
      label: Buyer.state,
      value: Buyer.statecode,
      id: Buyer.stateid,
    })
    setonecountrydefaultvalue({ label: Buyer.country, value: Buyer.country })
    setbankdefaultvalue({ label: Buyer.customer_name, value: Buyer.bank_id })
    setIsEdit(true)
    setImageInsert(false)
    setImageInsert1(false)
    setModal(true)
    setProofDocumentLoadAttach1(Buyer.Company_Logo_Web)
    setProofDocumentLoadAttach2(Buyer.Banner_Logo_Web)
    console.log(ImageInsert)
  }

  const onClickDelete = Buyer => {
    setDeletiid(Buyer.company_id)
    setDeleteModal(true)
  }

  const DeleteBuyer = async () => {
    const Deletbuy = await axios.instance
      .post(
        `/InsertCompanymstdelete`,
        {
          Company_Id: Deletiid,
          Optype: "Delete",
        },
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        }
      )
      .then(res => {
        console.log(res.data,'InsertCompanymstdelete')
        if (res.data.length === 0) {
          deleteScreenStock()
          setBuyererr(true)
          setDeleteModal(false)
          getallcustomers1(Active1)
        } else {
          toastr.error("Already Used Cannot be Deleted", "Company")
          setDeleteModal(false)
        }
      })
  }
  const deleteScreenStock = async () => {
    const Deletbuy = await axios.instance
      .delete(
        `/deleteScreenStock/${Deletiid}`,
        
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        }
      )
      .then(res => {
      
      })
  }

  // const [refreshState, setrefreshState] = useState(0)

  useEffect(() => {
    getallcustomers1(Active1)
  }, [Active1])

  // const getallcustomers = async () => {
  //   const get = await axios.instance
  //     .get(`/GetAllCompanyData/${"Y"}`, {
  //       headers: { Authorization: tokent, "Content-Type": "application/json" },
  //     })
  //     .then(res => {
  //       setallcustomercollections(res.data)
  //     })
  // }
  const insertstockrights = async (id) => {
    const get = await axios.instance
      .post(`/InsertStockRights`,
      { 
        Company_Id:id,
        Created_By:sessionStorage.getItem("Userid"),
        Created_Date:moment(new Date()).format("YYYY-MM-DD")

      }, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        // setallcustomercollections(res.data)
      })
  }

  const getallcustomers1 = async id => {
    const get = await axios.instance
      .get(`/GetAllCompanyData/${id === true ? "Y" : "N"}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        if (data.length > 0) {
          setallcustomercollections(res.data)
        } else {
          setActive1(true)
          setnoRecords(true)
        }
      })
  }

  const Getallcountrys = async () => {
    const get = await axios.instance
      .get("/Getallcountry", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.CountryName,
          value: b.CountryName,
        }))
        setallcountrycollections(options)
      })
  }

  const Getallstate = async () => {
    const get = await axios.instance
      .get("/GetallStates", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.StateName,
          value: b.StateCode,
          id: b.StateId,
        }))
        setallstatecollections(options)
      })
  }

  const Getallcity = async () => {
    const get = await axios.instance
      .get("/Getallcity", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.City_Name,
          value: b.City_Name,
        }))
        setallcitycollections(options)
      })
  }

  const getallbanks = async () => {
    const get = await axios.instance
      .get("/getallbanks", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.Customer_Name,
          value: b.Customer_Id,
        }))
        setbankcollectoin(options)
      })
  }

  useEffect(() => {
    Getallcountrys()
    getallcustomers1(true)
    Getallcity()
    Getallstate()
    getallbanks()
  }, [])

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        No
      </div>
    )
  }

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Yes
      </div>
    )
  }

  const columns = useMemo(
    () => [
      {
        Header: "Company Name",
        filterable: true,
        accessor: "company_name",
        disableFilters: true,
        filterable: true,
      },

      {
        Header: "Company Code",
        filterable: true,
        accessor: "company_code",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex justify-content-center align-items-center gap-2">
              <Tooltip title="Edit" placement="left-start">
                <Link
                  to="#"
                  className="text-primary"
                  onClick={() => {
                    const Buyer = cellProps.row.original
                    handleUserClick(Buyer)
                  }}
                >
                  <i
                    className="uil uil-pen font-size-18"
                    id="edittooltip"
                    style={{ color: "blue" }}
                  />
                </Link>
              </Tooltip>
              <Tooltip title="Delete" placement="right-end">
                <Link
                  to="#"
                  className="text-danger"
                  onClick={() => {
                    if (
                      JSON.parse(
                        sessionStorage.getItem("MenuItemCompanyControls")
                      ).Del == "Y"
                    ) {
                      const Buyer = cellProps.row.original
                      onClickDelete(Buyer)
                    } else {
                      toastr.warning(
                        "Please Contact Admin",
                        "Operation Not Allowed"
                      )
                    }
                  }}
                >
                  <i
                    className="uil uil-trash-alt font-size-18"
                    id="deletetooltip"
                  />
                </Link>
              </Tooltip>
            </div>
          )
        },
      },
    ],
    []
  )

  // company logo
  // const ImgOnchangeValue = async e => {
  //   setImageInsert(e.target.files[0])
  //   setProofDocumentLoad1(e.target.files[0])
  //   console.log(e.target.files[0])
  //   const filereader = new FileReader()
  //   filereader.readAsDataURL(e.target.files[0])
  //   filereader.onload = renderevent => {
  //     setProofDocumentLoadAttach1(renderevent.target.result)
  //     //window.open(e.target.value)
  //     console.log(e.target.files[0].name)
  //     setProofDocumentLoadName1(e.target.files[0])
  //   }
  // }

  const ImgOnchangeValue = async (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0]; // Get the selected file
  
      setImageInsert(file);
      setProofDocumentLoad1(file);
      console.log(file); // Log file object
  
      const filereader = new FileReader();
      
      filereader.onload = (renderevent) => {
        setProofDocumentLoadAttach1(renderevent.target.result); // Set base64 data
        console.log(file.name); // Log filename correctly
        setProofDocumentLoadName1(file);
      };
  
      filereader.readAsDataURL(file); // Read file as base64
    }
  };
  

  // Banner logo
  // const ImgOnchangeValue1 = async e => {
  //   setImageInsert1(e.target.files[0])
  //   setProofDocumentLoad2(e.target.files[0])
  //   console.log(e.target.files[0])
  //   const filereader = new FileReader()
  //   filereader.readAsDataURL(e.target.files[0])
  //   filereader.onload = renderevent => {
  //     setProofDocumentLoadAttach2(renderevent.target.result)
  //     //window.open(e.target.value)
  //     console.log(e.target.files[0].name, "Bannerlogo")
  //     setProofDocumentLoadName2(e.target.files[0])
  //   }
  // }

  const ImgOnchangeValue1 = async (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0]; // Store the file in a variable
  
      setImageInsert1(file);
      setProofDocumentLoad2(file);
      console.log(file, "Selected File");
  
      const filereader = new FileReader();
  
      filereader.onload = (renderevent) => {
        setProofDocumentLoadAttach2(renderevent.target.result);
        console.log(file.name, "Bannerlogo"); // Use `file.name` instead of `e.target.files[0].name`
        setProofDocumentLoadName2(file);
      };
  
      filereader.readAsDataURL(file); // Read the file as base64
    }
  };
  

  function productpreview(url) {
    setPopupimage(url)
    setopen(true)
  }

  const Closepopup = () => {
    setopen(false)
  }

  // Banner
  function productpreview1(url) {
    setPopupimage1(url)
    setopen1(true)
  }

  const Closepopup1 = () => {
    setopen1(false)
  }

  return (
    <React.Fragment>
      {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={() => DeleteBuyer()}
        onCloseClick={() => setDeleteModal(false)}
      /> */}
      <div className="page-content" style={{ backgroundColor: "inherit" }}>
        <div className="">
          <Row>
            <Col xs="12">
            <h6 className="titleviewinspections">Company Master</h6>
              <Card>
                <CardBody>
                  <div>
                    {/* <Breadcrumbs
                      title=" Master"
                      breadcrumbItem="Company Master"
                    /> */}
                  </div>
                  <Divider sx={{ mb: 2 }} />
                  <div className="d-flex justify-content-end align-items-center mt-3">
                    <Col
                      xl={12}
                      className="d-flex justify-content-end gap-2 align-items-center"
                    >
                      <div
                        className="d-flex d-flex-column gap-2 justify-content-end align-items-center pr-2"
                        style={{
                          borderRight: "1px solid #61677A",
                          paddingRight: "10px",
                        }}
                      >
                        <h5 className="font-size-14 mt-1">Active Company</h5>
                        <div className="mt-2 ml-2">
                          <Switch
                            onChange={checked => {
                              setActive1(checked)
                            }}
                            checked={Active1}
                            width={40}
                            height={20}
                          />
                        </div>
                      </div>
                      <CustomButton
                        variant="contained"
                        onClick={() => {
                          // if (
                          //   JSON.parse(
                          //     sessionStorage.getItem("MenuItemCompanyControls")
                          //   ).New == "Y"
                          // ) {
                            setIsEdit(false)
                            setactiveTab("1")
                            validation.resetForm()
                            setModal(true)
                          // } else {
                          //   toastr.warning(
                          //     "Please Contact Admin",
                          //     "Operation Not Allowed"
                          //   )
                          // }
                        }}
                        size="small"
                      >
                        Add Company
                      </CustomButton>
                    </Col>
                  </div>
                  {/* <TableContainer
                    columns={columns}
                    data={allcustomercollections}
                    isGlobalFilter={true}
                    isAddUsers={false}
                    isAddTableWithoutBorderStrap={true}
                  /> */}
                     <div>
                      {/* <Card className="">
                        <CardBody> */}
                      <div className="Tabelinspections">
                        <TableContainer>
                          <Table className="InspectionTbls">
                            <TableHead>
                              <TableRow>
                                <TableCell>Company Name </TableCell>
                                <TableCell align="left">Company Code</TableCell>                           
                                <TableCell>Edit</TableCell>
                                <TableCell>Delete</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {allcustomercollections.length != 0 ? (
                                changepage().map(data => (
                                  <TableRow key={data.Order_Id}>
                                    <TableCell style={{ textAlign: "left" }}>
                                      {data.company_name}
                                    </TableCell>
                                    <TableCell style={{ textAlign: "left" }}>
                                      {data.company_code}
                                    </TableCell>                                   
                                    <TableCell align="left">
                                      <IconButton size="small">
                                        {/* <VisibilityIcon fontSize="small"  */}
                                        <EditIcon
                                          fontSize="small"
                                          color="primary"
                                          onClick={() => {
                                            // editdata(data);
                                            console.log(data);
                                            // setdeleteid(data.Termsid);
                                            // setisedit(true);
                                          
                                            handleUserClick(data)
                                          }}
                                        />
                                      </IconButton>
                                    </TableCell>
                                    <TableCell align="left">
                                      <IconButton size="small">
                                        <DeleteIcon
                                          color="error"
                                          fontSize="small"
                                          onClick={() => {
                                            // setdeletedconfirm(true);
                                            // setdeleteid(data.Termsid);
                                            setdeletedconfirm(true);
                                            // toggledeletemodal(data.branch_id)
                                            setDeletiid(data.company_id)
                                          }}
                                        />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableCell align="left">NO Data Found</TableCell>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        <TablePagination
                          component="div"
                          rowsPerPageOptions={pages}
                          count={allcustomercollections.length}
                          rowsPerPage={rowsperpage}
                          page={page}
                          onChangePage={handleChangePage}
                          onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                      </div>
                      {/* <Backdrop open={open}>
                            <Spinner name="ball-spin-fade-loader" color="#fafafa" />
                            <p style={{ marginTop: '50px' }}></p>
                          </Backdrop> */}
                      {/* </CardBody>
                      </Card> */}

                    </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={modal} toggle={toggle} size="lg" centered>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit Company" : "Add Company"}
            </ModalHeader>
            <ModalBody>
              <div className="page-content ">
                <Container >
                  <Row>
                    <Col lg="12" className="mt-3">
                      {/* <Card>
                        <CardBody> */}
                      <Nav tabs>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "1",
                            })}
                            onClick={() => {
                              toggle12("1")
                            }}
                          >
                            <span className="d-block d-sm-none">
                              <i className="far fa-building"></i>
                            </span>
                            <span className="d-none d-sm-block">
                              Basic Info
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "2",
                            })}
                            onClick={() => {
                              tab1validtiontab1("2")
                            }}
                          >
                            <span className="d-block d-sm-none">
                              <i className="far fa-user"></i>
                            </span>
                            <span className="d-none d-sm-block">GST Info</span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "3",
                            })}
                            onClick={() => {
                              tab1validtiontab2("3")
                            }}
                          >
                            <span className="d-block d-sm-none">
                              <i className="fas fa-university"></i>
                            </span>
                            <span className="d-none d-sm-block">
                              Email Info
                            </span>
                          </NavLink>
                        </NavItem>
                      </Nav>

                      <TabContent
                        activeTab={activeTab}
                        className="p-3 text-muted"
                      >
                        <TabPane tabId="1">
                          <Row>
                            <Col lg="4">
                              <div className="mb-3">
                                <Label for="basicpill-company-input1">
                                  Company Name{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Company_Name"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-company-input1"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Company_Name || ""}
                                  invalid={
                                    validation.touched.Company_Name &&
                                    validation.errors.Company_Name
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.Company_Name &&
                                validation.errors.Company_Name ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Company_Name}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="2">
                              <div className="mb-3">
                                <Label for="basicpill-code-input2">
                                 Suffix
                                </Label>
                                <Input
                                  type="text"
                                  value={Suffix}
                                  onChange={e=>setSuffix(e.target.value)}
                                 
                                />
                              </div>
                            </Col>
                            <Col lg="3">
                              <div className="mb-3">
                                <Label for="basicpill-code-input2">
                                  Company Code
                                </Label>
                                <Input
                                  type="text"
                                  value={BuyerCollection.Company_Code}
                                  disabled
                                />
                              </div>
                            </Col>
                           
                            {/* <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                                      Under Group
                                    </Label>
                                    <Input  autoComplete="off"
                                      name="Contact_Person"
                                      type="text"
                                      className="form-control"
                                      id="basicpill-firstname-input1"
                                      defaultValue={subgroup}
                                      disabled
                                    />   
                                  </div>
                               </Col> */}
                            <Col lg="3">
                              <div className="mb-3">
                                <Label for="basicpill-contactperson-input2">
                                  Contact Person{" "}
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Contact_Person"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-contactperson-input2"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Contact_Person || ""}
                                  invalid={
                                    validation.touched.Contact_Person &&
                                    validation.errors.Contact_Person
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.Contact_Person &&
                                validation.errors.Contact_Person ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Contact_Person}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6 ">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-address1-input3">
                                  Address 1{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Address1"
                                  type="textarea"
                                  rows="3"
                                  className="form-control"
                                  style={{ margintop: 1 }}
                                  size="sm"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Address1 || ""}
                                  invalid={
                                    validation.touched.Address1 &&
                                    validation.errors.Address1
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.Address1 &&
                                validation.errors.Address1 ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Address1}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="6">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-address2-input3">
                                  Address 2
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Address2"
                                  type="textarea"
                                  rows="3"
                                  className="form-control"
                                  style={{ margintop: 1 }}
                                  size="sm"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Address2 || ""}
                                  invalid={
                                    validation.touched.Address2 &&
                                    validation.errors.Address2
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row className="mt-1">
                            <Col lg="4">
                              <div className="mb-0">
                                <Label>
                                  Country{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Select
                                  name="Country"
                                  options={allcountrycollections}
                                  classNamePrefix="select2-search-disable"
                                  value={onecountrydefaultvalue}
                                  onChange={value => {
                                    setonecountrydefaultvalue(value)
                                  }}
                                />
                                {countryErr ? (
                                  <p
                                    style={{ fontSize: "12px" }}
                                    className="error"
                                  >
                                    Please Select Country{" "}
                                  </p>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="4">
                              <div className="mb-0">
                                <Label>
                                  State <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Select
                                  name="State"
                                  options={allstatecollections}
                                  classNamePrefix="select2-search-disable"
                                  value={onestatedefaultvalue}
                                  onChange={value => {
                                    setonestatedefaultvalue(value)
                                    validation.values.TNGST = value.value
                                  }}
                                />
                                {stateErr ? (
                                  <p
                                    style={{ fontSize: "12px" }}
                                    className="error"
                                  >
                                    Please Select State{" "}
                                  </p>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="4">
                              <div className="mb-0 ">
                                <Label for="basicpill-phone-input1">
                                  Phone No{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Phone"
                                  type="number"
                                  className="form-control"
                                  id="basicpill-phone-input1"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Phone || ""}
                                  invalid={
                                    validation.touched.Phone &&
                                    validation.errors.Phone
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.Phone &&
                                validation.errors.Phone ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Phone}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                          <Row className="mt-1">
                            <Col lg="4">
                              <div className="mb-0">
                                <Label for="basicpill-city-input4">
                                  City <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Select
                                  name="CategoryId"
                                  options={allcitycollections}
                                  classNamePrefix="select2-search-disable"
                                  value={cityonedefaultvalue}
                                  onChange={value => {
                                    setcityonedefaultvalue(value)
                                  }}
                                />
                                {cityErr ? (
                                  <p
                                    style={{ fontSize: "12px" }}
                                    className="error"
                                  >
                                    Please Select City{" "}
                                  </p>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="4">
                              <div className="mb-0">
                                <Label for="basicpill-pincode-input1">
                                  Pin Code{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Zip_Code"
                                  type="number"
                                  className="form-control"
                                  id="basicpill-pincode-input1"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Zip_Code || ""}
                                  invalid={
                                    validation.touched.Zip_Code &&
                                    validation.errors.Zip_Code
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.Zip_Code &&
                                validation.errors.Zip_Code ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Zip_Code}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="4">
                              <div className="mb-0 ">
                                <Label for="basicpill-mobile-input1">
                                  Mobile No
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Area_Code"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-mobile-input1"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Area_Code || ""}
                                  invalid={
                                    validation.touched.Area_Code &&
                                    validation.errors.Area_Code
                                      ? true
                                      : false
                                  }
                                />

                                {/* {validation.touched.Phone && validation.errors.Phone ? (
                         <FormFeedback type="invalid">{validation.errors.Phone}</FormFeedback>
                       ) : null} */}
                              </div>
                            </Col>
                          </Row>
                          {/* <Row>

                          
                               <Col lg="4" >
                                         <div className="mb-0 " >
                                     
                            
                              
                                 
                                   <Label for="basicpill-address-input1">
                                   Email Id <span style={{color:"red"}}>*</span>
                               </Label>
                               <Input
                                 autoComplete="off"
                               name="EmailId"
                                     type="email"
                                     className="form-control"
                                     id="basicpill-email-input4"
                                     onChange={validation.handleChange}
                                     onBlur={validation.handleBlur}
                                     value={validation.values.EmailId || ""}
                                     invalid={
                                       validation.touched.EmailId && validation.errors.EmailId ? true : false
                                     }
                                   />
                                                {validation.touched.EmailId && validation.errors.EmailId ? (
                         <FormFeedback type="invalid">{validation.errors.EmailId}</FormFeedback>
                       ) : null}
                              
                              
                                 </div>
                               </Col>
                            
                             </Row> */}
                          <Row className="mt-1">
                            <Col lg="4">
                              <div className="mb-0 ">
                                <Label for="basicpill-fax-input1">Fax</Label>
                                <Input
                                  autoComplete="off"
                                  name="Fax"
                                  type="number"
                                  className="form-control"
                                  id="basicpill-fax-input1"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Fax || ""}
                                  invalid={
                                    validation.touched.Fax &&
                                    validation.errors.Fax
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.Fax &&
                                validation.errors.Fax ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Fax}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="4">
                              <div className="mb-0 ">
                                <Label for="basicpill-pan-input1">
                                  PAN No <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="PAN_No"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-pan-input1"
                                  autoCapitalize="on"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.PAN_No || ""}
                                  invalid={
                                    validation.touched.PAN_No &&
                                    validation.errors.PAN_No
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.PAN_No &&
                                validation.errors.PAN_No ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.PAN_No}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="4">
                              <div className="mb-0 ">
                                <Label for="basicpill-website-input1">
                                  Web Site
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="WebSit"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-website-input1"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.WebSit || ""}
                                  invalid={
                                    validation.touched.WebSit &&
                                    validation.errors.WebSit
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row className="mt-1">
                            <Col lg="4">
                              <div className="mb-0 ">
                                <Label for="basicpill-prefix-input1">
                                  Prefix
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Prefix"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-prefix-input1"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Prefix || ""}
                                  invalid={
                                    validation.touched.Prefix &&
                                    validation.errors.Prefix
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>
                            <Col lg="4">
                              <div className="mb-0 ">
                                <Label for="basicpill-banner-input1">
                                  Banner
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Banner"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-banner-input1"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Banner || ""}
                                  invalid={
                                    validation.touched.Banner &&
                                    validation.errors.Banner
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>
                            <Col lg="4">
                              <div className="mb-0 ">
                                <Label for="basicpill-drug-input1">
                                  Drug License
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="DrugLicense"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-drug-input1"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.DrugLicense || ""}
                                  invalid={
                                    validation.touched.DrugLicense &&
                                    validation.errors.DrugLicense
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row className="mt-1">
                            <Col lg="4">
                              <div className="mb-0 ">
                                <Label for="basicpill-bank-input1">Bank</Label>
                                <Select
                                  name="Bank"
                                  options={bankcollectoin}
                                  value={bankdefaultvalue}
                                  classNamePrefix="select2-search-disable"
                                  onChange={value => {
                                    setbankdefaultvalue(value)
                                  }}
                                />
                              </div>
                            </Col>

                            <Col xl={6}>
                              <p className="font-size-14 mb-3">Active</p>
                              {isEdit ? (
                                <div className="mt-2">
                                  {
                                    (allcustomercollections.Active = "Y" ? (
                                      <Switch
                                        uncheckedIcon={<Offsymbol />}
                                        checkedIcon={<OnSymbol />}
                                        onColor="#626ed4"
                                        onChange={() => {
                                          setswitch1(!switch1)
                                        }}
                                        checked={switch1}
                                      />
                                    ) : (
                                      <Switch
                                        uncheckedIcon={<Offsymbol />}
                                        checkedIcon={<OnSymbol />}
                                        onColor="#626ed4"
                                        onChange={() => {
                                          setswitch1(switch1)
                                        }}
                                        checked={!switch1}
                                      />
                                    ))
                                  }
                                </div>
                              ) : (
                                <div className="mt-2">
                                  <Switch
                                    uncheckedIcon={<Offsymbol />}
                                    checkedIcon={<OnSymbol />}
                                    onColor="#626ed4"
                                    onChange={() => {
                                      setswitch1(!switch1)
                                    }}
                                    checked={switch1}
                                  />
                                </div>
                              )}
                            </Col>
                            </Row>
                            <Row className="mt-2">
                            <Col lg="3">
                              <div className="mb-3">
                                <Label for="basicpill-address-input1 pl-2 ">
                                  Company Logo
                                </Label>
                                <div
                                  onClick={() =>
                                    document
                                      .getElementById("CompanyLogo")
                                      .click()
                                  }
                                  className="d-flex justify-content-center align-items-center "
                                >
                                  <CustomButton2
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<CloudUploadIcon />}
                                    size="small"
                                    sx={{ textTransform: "capitalize" }}
                                    fullWidth
                                  >
                                    Choose Image
                                  </CustomButton2>
                                  <Input
                                    id="CompanyLogo"
                                    name="price"
                                    type="file"
                                    accept="image/*"
                                    onChange={ImgOnchangeValue}
                                    className="form-control"
                                    hidden
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col lg="3" style={{ margin: "auto" }}>
                              {isEdit ? (
                                <>
                                  {!ImageInsert ? (
                                    <>
                                      {ProofDocumentLoadAttach1 && (
                                        <div className="d-flex justify-content-start align-items-center gap-2">
                                          <TrendingFlatIcon
                                            color="info"
                                            sx={{ mr: 2 }}
                                          />
                                          <img
                                            src={
                                              `${axios.baseURL +'CompanyImg/'}` +
                                              ProofDocumentLoadAttach1
                                            }
                                            width="100px"
                                            height="70px"
                                            style={{
                                              objectFit: "contain",
                                              border: 0,
                                              cursor: "pointer",
                                            }}
                                            className="imagePreview"
                                            onClick={() =>
                                              productpreview(
                                                `${
                                                  `${axios.baseURL +'CompanyImg/'}` +
                                                  ProofDocumentLoadAttach1
                                                }`
                                              )
                                            }
                                          />
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {ProofDocumentLoadAttach1 && (
                                        <div className="d-flex justify-content-start align-items-center gap-2">
                                          <TrendingFlatIcon
                                            color="info"
                                            sx={{ mr: 2 }}
                                          />
                                          <img
                                            src={ProofDocumentLoadAttach1}
                                            width="100px"
                                            height="70px"
                                            style={{
                                              objectFit: "contain",
                                              border: 0,
                                              cursor: "pointer",
                                            }}
                                            className="imagePreview"
                                            onClick={() =>
                                              productpreview(
                                                ProofDocumentLoadAttach1
                                              )
                                            }
                                          />
                                        </div>
                                      )}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {ProofDocumentLoadAttach1 && (
                                    <div className="d-flex justify-content-start align-items-center gap-2">
                                      <TrendingFlatIcon
                                        color="info"
                                        sx={{ mr: 2 }}
                                      />
                                      <img
                                        src={ProofDocumentLoadAttach1}
                                        width="100px"
                                        height="70px"
                                        style={{
                                          objectFit: "contain",
                                          border: 0,
                                          cursor: "pointer",
                                        }}
                                        className="imagePreview"
                                        onClick={() =>
                                          productpreview(
                                            ProofDocumentLoadAttach1
                                          )
                                        }
                                      />
                                    </div>
                                  )}
                                </>
                              )}
                            </Col>

                            <Col lg="3">
                              <div className="mb-3">
                                <Label for="basicpill-address-input1 pl-2 ">
                                  Banner Logo
                                </Label>
                                <div
                                  onClick={() =>
                                    document.getElementById("BrandLogo").click()
                                  }
                                  className="d-flex justify-content-center align-items-center "
                                >
                                  <CustomButton2
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<CloudUploadIcon />}
                                    size="small"
                                    sx={{ textTransform: "capitalize" }}
                                    fullWidth
                                  >
                                    Choose Image
                                  </CustomButton2>
                                  <Input
                                    id="BrandLogo"
                                    name="price"
                                    type="file"
                                    accept="image/*"
                                    onChange={ImgOnchangeValue1}
                                    className="form-control"
                                    hidden
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col lg="3" style={{ margin: "auto" }}>
                              {isEdit ? (
                                <>
                                  {!ImageInsert1 ? (
                                    <>
                                      {ProofDocumentLoadAttach2 && (
                                        <div className="d-flex justify-content-start align-items-center gap-2">
                                          <TrendingFlatIcon
                                            color="info"
                                            sx={{ mr: 2 }}
                                          />
                                          <img
                                            src={
                                              `${axios.baseURL +'CompanyImg/'}` +
                                              ProofDocumentLoadAttach2
                                            }
                                            width="100px"
                                            height="70px"
                                            style={{
                                              objectFit: "contain",
                                              border: 0,
                                              cursor: "pointer",
                                            }}
                                            className="imagePreview"
                                            onClick={() =>
                                              productpreview(
                                                `${axios.baseURL +'CompanyImg/'}` +
                                                  ProofDocumentLoadAttach2
                                              )
                                            }
                                          />
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {ProofDocumentLoadAttach2 && (
                                        <div className="d-flex justify-content-start align-items-center gap-2">
                                          <TrendingFlatIcon
                                            color="info"
                                            sx={{ mr: 2 }}
                                          />
                                          <img
                                            src={ProofDocumentLoadAttach2}
                                            width="100px"
                                            height="70px"
                                            style={{
                                              objectFit: "contain",
                                              border: 0,
                                              cursor: "pointer",
                                            }}
                                            className="imagePreview"
                                            onClick={() =>
                                              productpreview(
                                                ProofDocumentLoadAttach2
                                              )
                                            }
                                          />
                                        </div>
                                      )}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {ProofDocumentLoadAttach2 && (
                                    <div className="d-flex justify-content-start align-items-center gap-2">
                                      <TrendingFlatIcon
                                        color="info"
                                        sx={{ mr: 2 }}
                                      />
                                      <img
                                        src={ProofDocumentLoadAttach2}
                                        width="100px"
                                        height="70px"
                                        style={{
                                          objectFit: "contain",
                                          border: 0,
                                          cursor: "pointer",
                                        }}
                                        className="imagePreview"
                                        onClick={() =>
                                          productpreview1(
                                            ProofDocumentLoadAttach2
                                          )
                                        }
                                      />
                                    </div>
                                  )}
                                </>
                              )}
                            </Col>

                           
                          </Row>

                          <Row>
                            <div className="d-flex flex-wrap gap-3 justify-content-end mt-4">
                              <Button
                                style={{
                                  backgroundColor: "#0766AD",
                                  color: "White",
                                }}
                                color="primary"
                                className="waves-effect waves-light"
                                onClick={() => {
                                  tab1validtiontab1("2")
                                }}
                              >
                                Next
                              </Button>{" "}
                            </div>
                          </Row>
                        </TabPane>
                        <TabPane tabId="2" style={{ minHeight: "50vh" }}>
                          <Form>
                            <Row>
                              <Col lg="4">
                                <div className="mb-0 ">
                                  <Label for="basicpill-lutarn-input1">
                                    LUT ARN
                                  </Label>
                                  <Input
                                    autoComplete="off"
                                    name="CST"
                                    type="Text"
                                    className="form-control"
                                    id="basicpill-lutarn-input1"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.CST || ""}
                                    invalid={
                                      validation.touched.CST &&
                                      validation.errors.CST
                                        ? true
                                        : false
                                    }
                                  />
                                </div>
                              </Col>

                              <Col lg="4">
                                <div className="mb-3">
                                  <Label for="basicpill-lutdate-input6">
                                    LUT Date
                                  </Label>
                                  <Input
                                    autoComplete="off"
                                    type="date"
                                    name="MobileNo"
                                    min={"1000-01-01"}
                                    max={"9999-12-31"}
                                    className="form-control"
                                    id="basicpill-lutdate-input6"
                                    value={moment(registerdate).format(
                                      "YYYY-MM-DD"
                                    )}
                                    onChange={e =>
                                      setregisterdate(e.target.value)
                                    }
                                  />
                                </div>
                              </Col>
                              <Col lg="4">
                                <div className="mb-3">
                                  <Label for="basicpill-gst-input7">
                                    GSTIN/UIN{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    autoComplete="off"
                                    type="text"
                                    name="TNGST"
                                    className="form-control"
                                    id="basicpill-gst-input7"
                                    //    disabled={gsttrue}
                                    // onChange={validation.handleChange}
                                    maxLength={15}
                                    onChange={e => {
                                      const newValue = e.target.value
                                      const currentValue =
                                        validation.values.TNGST || ""
                                      // Check if the new value doesn't overwrite the first two digits
                                      if (
                                        newValue.length >= 2 &&
                                        newValue.substring(0, 2) ===
                                          currentValue.substring(0, 2)
                                      ) {
                                        // Update the value
                                        validation.handleChange(e)
                                      }
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.TNGST || ""}
                                    invalid={
                                      validation.touched.TNGST &&
                                      validation.errors.TNGST
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.TNGST &&
                                  validation.errors.TNGST ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.TNGST}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>

                              {/* <Col lg="5">
                                   <div className="mb-3">
                                     <Label for="basicpill-cstno-input7">
                                      PAN No
                                 </Label>
                                     <Input
                                       autoComplete="off"
                                       type="text"
                                         name="PANNo"
                                       className="form-control"
                                       id="basicpill-cstno-input7"
                                       
                                         onChange={validation.handleChange}
                                         onBlur={validation.handleBlur}
                                         value={validation.values.PANNo || ""}
                                         invalid={
                                           validation.touched.PANNo && validation.errors.PANNo ? true : false
                                         }
                                       />
                            
                                   </div>
                                 </Col>
                                 <Col lg="4">
                                   <div className="mb-3">
                                     <Label for="basicpill-vatno-input6">
                                  CIN
                                 </Label>
                                     <Input
                                       autoComplete="off"
                                       name="TIN_No"
                                       type="text"
                                       className="form-control"
                                       id="basicpill-vatno-input6"
                                   
                                  
                                     onChange={validation.handleChange}
                                     onBlur={validation.handleBlur}
                                     value={validation.values.TIN_No || ""}
                                     invalid={
                                       validation.touched.TIN_No && validation.errors.TIN_No ? true : false
                                     }
                                   />
                          
                                   </div>
                                 </Col>
                                 <Col xl={2}>
                    <h5 className="font-size-14 mt-1">
                        IGST Apllicable  
                    </h5>
                    
                        <div className="mt-2">
                           
                                
                            <Switch 
                                onChange={(checked)=>{
                                    {checked?
                                    setuseractive(true)
                                    :
                                    setuseractive(false)
                                    }
                                 
                                }} 
                                checked={useractive} 
                            
                                width={40}
                                height={20}
                            /> 
                          
                        
                        </div>                                              
                                </Col>  */}
                            </Row>
                            <Row></Row>
                            <Row>
                              <div className="d-flex flex-wrap gap-3 justify-content-end mb-3">
                                <Button
                                  style={{
                                    backgroundColor: "#0766AD",
                                    color: "white",
                                  }}
                                  color="primary"
                                  className="waves-effect waves-light"
                                  onClick={() => {
                                    tab1validtiontab2("3")
                                  }}
                                >
                                  Next
                                </Button>{" "}
                              </div>
                            </Row>
                          </Form>
                        </TabPane>
                        <TabPane tabId="3" style={{ minHeight: "50vh" }}>
                          <Row>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label for="basicpill-emailid-input12">
                                  Email Id
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="EmailId"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-emailid-input12"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.EmailId || ""}
                                  invalid={
                                    validation.touched.EmailId &&
                                    validation.errors.EmailId
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.EmailId &&
                                validation.errors.EmailId ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.EmailId}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>

                            <Col lg="6">
                              <div className="mb-3">
                                <Label for="basicpill-mailpassword-input">
                                  Mail Password
                                </Label>
                                <Input
                                  autoComplete="off"
                                  type="password"
                                  name="mailpassword"
                                  className="form-control"
                                  id="basicpill-mailpassword-input"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.mailpassword || ""}
                                  invalid={
                                    validation.touched.mailpassword &&
                                    validation.errors.mailpassword
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label for="basicpill-smtpport-input12">
                                  SMTP Port
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="SMTPPort"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-smtpport-input12"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.SMTPPort || ""}
                                  invalid={
                                    validation.touched.SMTPPort &&
                                    validation.errors.SMTPPort
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>

                            <Col lg="6">
                              <div className="mb-3">
                                <Label for="basicpill-smtpserver-input">
                                  Outgoing SMTP Server
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="SMTPServer"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-smtpserver-input"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.SMTPServer || ""}
                                  invalid={
                                    validation.touched.SMTPServer &&
                                    validation.errors.SMTPServer
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>

                            <Col lg="6">
                              <div className="mb-3">
                                <Label for="basicpill-ccmailid-input">
                                  CC Mail Id
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="CCEmailId"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-ccmailid-input"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.CCEmailId || ""}
                                  invalid={
                                    validation.touched.CCEmailId &&
                                    validation.errors.CCEmailId
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.CCEmailId &&
                                validation.errors.CCEmailId ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.CCEmailId}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>

                            <Col xl={6}>
                              <h5 className="font-size-14 mt-1">
                                SSL Required
                              </h5>

                              <div className="mt-2">
                                <Switch
                                  onChange={checked => {
                                    {
                                      setActive2(checked)
                                    }

                                    // GetallCategory1(checked)
                                  }}
                                  checked={Active2}
                                  width={40}
                                  height={20}
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label for="basicpill-invoiceusername-input">
                                  E-invoice Username
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Invoice_username"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-invoiceusername-input"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={
                                    validation.values.Invoice_username || ""
                                  }
                                  invalid={
                                    validation.touched.Invoice_username &&
                                    validation.errors.Invoice_username
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>

                            <Col lg="6">
                              <div className="mb-3">
                                <Label for="basicpill-invoicepass-input">
                                  E-invoice Password
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Invoice_password"
                                  type="password"
                                  className="form-control"
                                  id="basicpill-invoicepass-input"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={
                                    validation.values.Invoice_password || ""
                                  }
                                  invalid={
                                    validation.touched.Invoice_password &&
                                    validation.errors.Invoice_password
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              {isEdit ? (
                                <div className="d-flex flex-wrap gap-3 justify-content-end mb-3 mt-5">
                                  <Button
                                    style={{
                                      backgroundColor: "#0766AD",
                                      color: "White",
                                    }}
                                    color="primary"
                                    className="waves-effect waves-light"
                                    onClick={e => {
                                      e.preventDefault()

                                      // if (
                                      //   JSON.parse(
                                      //     sessionStorage.getItem(
                                      //       "MenuItemCompanyControls"
                                      //     )
                                      //   ).Edit == "Y"
                                      // ) {
                                        validation.handleSubmit()
                                      // } else {
                                      //   toastr.warning(
                                      //     "Please Contact Admin",
                                      //     "Operation Not Allowed"
                                      //   )
                                      // }
                                      return false
                                    }}
                                  >
                                    Update
                                  </Button>{" "}
                                </div>
                              ) : (
                                <div className="d-flex flex-wrap gap-3 justify-content-end mb-3 mt-5">
                                  <Button
                                    style={{
                                      color: "white",
                                      backgroundColor: "#0766AD",
                                    }}
                                    color="primary"
                                    onClick={e => {
                                      e.preventDefault()
                                      validation.handleSubmit()
                                      return false
                                    }}
                                  >
                                    Save
                                  </Button>{" "}
                                </div>
                              )}
                            </Col>
                          </Row>
                        </TabPane>
                      </TabContent>
                    
                    </Col>
                  </Row>
                </Container>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </div>

      <Dialog
        onClose={Closepopup}
        aria-labelledby="simple-dialog-title"
        open={open}
        style={{ background: "none" }}
      >
        <img
          src={Popupimage}
          style={{ width: "400px", height: "400px", objectFit: "contain" }}
        />
      </Dialog>

      <Dialog
        onClose={Closepopup1}
        aria-labelledby="simple-dialog-title"
        open={open1}
        style={{ background: "none" }}
      >
        <img
          src={Popupimage1}
          style={{ width: "400px", height: "400px", objectFit: "contain" }}
        />
      </Dialog>

      {Buyersuccess ? (
        <SweetAlert
          title="Company Added Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setBuyersuccess(false)
          }}
        ></SweetAlert>
      ) : null}

      {Buyerinfo ? (
        <SweetAlert
          title="Company Updated Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setBuyerinfo(false)
          }}
        ></SweetAlert>
      ) : null}

      {Buyererr ? (
        <SweetAlert
          title="Company Deleted Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setBuyererr(false)
          }}
        ></SweetAlert>
      ) : null}
      {CantDeleteErr ? (
        <SweetAlert
          title="Already Used Cannot be Deleted"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setCantDeleteErr(false)
          }}
        ></SweetAlert>
      ) : null}

      {duplicateerro ? (
        <SweetAlert
          title="Company Already exists "
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          danger
          onConfirm={() => {
            setduplicateerro(false)
          }}
        ></SweetAlert>
      ) : null}

      {noRecords ? (
        <SweetAlert
          title="No Records Found for InActive"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setnoRecords(false)
          }}
        ></SweetAlert>
      ) : null}

        {deletedconfirm ? (
                    <SweetAlert
                      title="Are You Sure?"
                      style={{
                        position: 'absolute',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                      confirmBtnBsStyle="success"
                      showConfirm={true}
                      cancelBtnBsStyle="danger"
                      cancelBtnText="Cancel"
                      confirmBtnText="Yes,delete it!"
                      showCancel={true}
                      warning
                      onConfirm={() => {
                        DeleteBuyer();
                        setdeletedconfirm(false);
                      }}
                      onCancel={() => {
                        setdeletedconfirm(false);
                        // setdeleted(false);
                      }}
                    >
                      <p style={{ fontSize: '20px' }}>You Won't able to revert this!</p>
                    </SweetAlert>
                  ) : null}
    </React.Fragment>
  )
}
CompanyMaster.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default CompanyMaster
